import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "@/components/Reveal";
import { ServiceIcon } from "@/components/ServiceIcon";
import { sentenceCase } from "@/lib/text";

export const ServicesGrid = ({ showHeader = true }) => {
  const { lang, t } = useLang();
  const pastels = ["bg-pastel-violet", "bg-pastel-blue", "bg-pastel-yellow"];
  return (
    <section className="py-14 md:py-20 border-t border-navy/5" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {showHeader && (
          <Reveal className="max-w-2xl mb-14 md:mb-20">
            <Overline>{t.servicesSection.overline}</Overline>
            <h2 className="font-display text-4xl md:text-5xl leading-[1.08] tracking-tight text-navy mt-4">
              {t.servicesSection.title}
            </h2>
            <p className="mt-5 text-base md:text-lg text-navy/70">{t.servicesSection.intro}</p>
          </Reveal>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.services.map((s, i) => (
            <Reveal key={s.id} delay={0.06 * (i % 3)}>
              <Link
                to={`/${lang}/services/${s.id}`}
                data-testid={`service-card-${s.id}`}
                className={`group flex flex-col h-full ${pastels[i % 3]} border border-navy/10 p-8 hover:border-ser-purple/40 hover:-translate-y-1 hover:shadow-[0_18px_40px_-18px_rgba(24,26,48,0.25)] transition-[transform,box-shadow,border-color] duration-300`}
              >
                <div className="w-12 h-12 flex items-center justify-center bg-white mb-6">
                  <ServiceIcon name={s.icon} />
                </div>
                <h3 className="font-display text-2xl leading-snug text-navy group-hover:text-ser-purple transition-colors">
                  {sentenceCase(s.name)}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-navy/65 flex-1">{s.short}</p>
                <span className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.15em] font-medium text-ser-purple">
                  {t.servicesSection.learnMore}
                  <ArrowRight size={14} strokeWidth={1.5} className="transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
